import axios from 'axios'
// 导入弹框提示组件
//import { Message } from 'element-ui'

// import { store } from '@/store/index.js'
// 自定义实例默认值
const service = axios.create({
	// 47.105.208.217
	//配置请求的根路径
    // target: "http://www.ds.com",
    // target: "http://localhost:8099/",
  // target: "http://123.57.229.160:8099/",
    // target: "http://192.168.101.11:8099/",
	// headers:{ accessToken:sessionStorage.getItem("token") },
    // withCredentials: false,
    timeout: 200000
})

// 请求拦截器
//所有的网络请求都会先走这个方法
service.interceptors.request.use(
    config => {
		// if(store.state.token){
		// 	config.headers.Authorization = store.state.token;
		// }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
//所有的网络请求返回数据之后都会先走这个方法
service.interceptors.response.use(
    response => {
        const res = response.data
        if (response.status !== 200) {
            // Message({
            //     message: 'error',
            //     type: 'error',
            //     duration: 5 * 1000
            // })
            // return Promise.reject('error')
        } else {
            return res
        }
    },
    error => {
        // Message({
        //     message: 'error',
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        // return Promise.reject(error)
    }
)

export default service



//////////////////
// WEBPACK FOOTER
// ./config/request.js
// module id = null
// module chunks = 